import React from 'react';
import EstudiantesScreen from '../EstudiantesScreen/EstudiantesScreen';

function EstudiantesConsultaScreen() {
  return <EstudiantesScreen readOnly={true} screenTitle="Estudiantes Consulta" />;
}

export default EstudiantesConsultaScreen;
